import { BaseView } from './BaseView';
import { registerSchema } from './transform';

export class WeightRecord {
  Id: number = 0;
  DateWeighted: Date = new Date();
  WeightKg: number = 0;
  Notes: string = '';
}

export class WeightListView extends BaseView {
  Items: WeightRecord[] = [];
}

export class WeightChartPoint {
  StartDate: Date = new Date();
  AvgWeightKg: number | null = null;
}

export class WeightChartData {
  Granularity: string = '';
  Points: WeightChartPoint[] = [];
}

registerSchema(WeightRecord, {
  DateWeighted: 'date',
});

registerSchema(WeightListView, {
  Items: [WeightRecord],
});

registerSchema(WeightChartPoint, {
  StartDate: 'date',
});

registerSchema(WeightChartData, {
  Points: [WeightChartPoint],
});
